export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Modyfikatory',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować menu. Odśwież i spróbuj ponownie',
  },
};
